/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_TInputs */

const en_mk_tut_apa_t = /** @type {(inputs: Mk_Tut_Apa_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What KerjaBareng is`)
};

const id_mk_tut_apa_t = /** @type {(inputs: Mk_Tut_Apa_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa itu KerjaBareng`)
};

/**
* | output |
* | --- |
* | "What KerjaBareng is" |
*
* @param {Mk_Tut_Apa_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_t = /** @type {((inputs?: Mk_Tut_Apa_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_t(inputs)
	return en_mk_tut_apa_t(inputs)
});